import {
  LayoutDashboard,
  Target,
  Users,
  UserCircle,
  Mail,
  MailOpen,
  PhoneCall,
  PhoneOutgoing,
  Phone,
  CheckCircle,
  TrendingUp,
  Route,
  Shield,
  Bell,
  Radar,
  BarChart3,
  Activity,
} from 'lucide-react';
import type { Module } from '@/config/permissions';

export interface RibbonItem {
  name: string;
  href: string;
  icon: any;
  module: Module;
  always?: boolean; // show regardless of module permission (e.g. personal pages)
}

export interface RibbonGroup {
  label: string;
  items: RibbonItem[];
}

export interface RibbonTab {
  id: string;
  label: string;
  groups: RibbonGroup[];
}

// Office-style ribbon: tabs → groups → command buttons, ordered along the ABM funnel.
export const ribbonTabs: RibbonTab[] = [
  {
    id: 'home',
    label: 'Home',
    groups: [
      {
        label: 'Overview',
        items: [
          { name: 'Dashboard', href: '/dashboard', icon: LayoutDashboard, module: 'dashboard' },
          { name: 'Notifications', href: '/notifications', icon: Bell, module: 'dashboard', always: true },
        ],
      },
      {
        label: 'Pipeline',
        items: [
          { name: 'Prospecting', href: '/prospecting', icon: Target, module: 'prospecting' as Module },
          { name: 'Accounts', href: '/accounts', icon: Users, module: 'accounts' },
          { name: 'Contacts', href: '/contacts', icon: UserCircle, module: 'contacts' },
          { name: 'Journeys', href: '/abm-journeys', icon: Route, module: 'abm_journey' },
        ],
      },
      {
        label: 'Insights',
        items: [
          { name: 'Activity', href: '/activity', icon: Activity, module: 'dashboard', always: true },
          { name: 'Reports', href: '/reports', icon: BarChart3, module: 'reports' as Module },
        ],
      },
    ],
  },
  {
    id: 'engagement',
    label: 'Engagement',
    groups: [
      {
        label: 'Outreach',
        items: [
          { name: 'Magnets', href: '/magnets', icon: Mail, module: 'magnets' },
          { name: 'Magnet Portal', href: '/magnet-portal', icon: Radar, module: 'magnets' },
          { name: 'Calls', href: '/calls', icon: Phone, module: 'call_management' },
        ],
      },
      {
        label: 'AI Agents',
        items: [
          { name: 'Email Agent', href: '/email-agent', icon: MailOpen, module: 'call_management' as Module },
          { name: 'Voice Agent', href: '/voice-agent', icon: PhoneCall, module: 'call_management' as Module },
          { name: 'AI Calling', href: '/ai-calling', icon: PhoneOutgoing, module: 'call_management' as Module },
        ],
      },
    ],
  },
  {
    id: 'qualification',
    label: 'Qualification',
    groups: [
      {
        label: 'MQL',
        items: [
          { name: 'Readiness', href: '/mql-readiness', icon: TrendingUp, module: 'mql_gate' },
          { name: 'MQL Gate', href: '/mql', icon: CheckCircle, module: 'mql_gate' },
        ],
      },
    ],
  },
  {
    id: 'admin',
    label: 'Admin',
    groups: [
      {
        label: 'Administration',
        items: [
          { name: 'Users', href: '/users', icon: Shield, module: 'users' },
        ],
      },
    ],
  },
];

// True if the current path matches a nav href (exact, or a nested route under it).
export const isPathActive = (pathname: string, href: string) =>
  pathname === href || pathname.startsWith(href + '/');
